import { useFormikContext } from "formik"
import { makeStyles } from "tss-react/mui"
import { Checkbox, FormControlLabel, FormGroup, Grid, Stack, Typography } from "@mui/material"
import { StandardButton } from "../../../../../../../shared/components/buttons/StandardButton"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import {
    fetchMerchantSettingsOnboardingArticles,
    MerchantSettingsOnboardingArticlesResponse,
    SupplierMerchantQuery,
} from "../../supplierMerchantsApi"
import { BeginOnboardingFormValues } from "../../supplierMerchantsTypes"
import { useMerchant } from "../../../../../../merchants/merchantHooks"
import { useApiQuery } from "../../../../../../../core/api/useApiQuery"

const useStyles = makeStyles()((theme) => ({
    groupTitle: {
        marginBottom: theme.spacing(1),
    },
}))

type FirstStepProps = Readonly<{
    handleNext: () => void
}>
function transformData(data: MerchantSettingsOnboardingArticlesResponse) {
    return data.onboardingArticles
}
export function FirstStep({ handleNext }: FirstStepProps) {
    const { classes } = useStyles()
    const { merchantId } = useMerchant()
    const { values, setFieldValue } = useFormikContext<BeginOnboardingFormValues>()

    const { data: onboardingArticles = [] } = useApiQuery(fetchMerchantSettingsOnboardingArticles, {
        queryName: SupplierMerchantQuery.MERCHANT_BEGIN_ONBOARDING_ARTICLES,
        dependencies: {
            merchantId,
        },
        select: transformData,
        suspense: true,
        useErrorBoundary: true,
    })
    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, articleId: number) => {
        const updatedArticles = event.target.checked
            ? [...values.articles, { id: articleId }]
            : values.articles.filter((article) => article.id !== articleId)

        setFieldValue("articles", updatedArticles)
    }

    const isChecked = (articleId: number) => values.articles.some((article) => article.id === articleId)

    return (
        <Stack gap="2rem">
            {!!onboardingArticles.length &&
                onboardingArticles.map((article, index) => (
                    <Stack>
                        <Typography variant="h6" className={classes.groupTitle}>
                            {article.folder}
                        </Typography>
                        <FormGroup>
                            {article.files.map((file) => (
                                <FormControlLabel
                                    key={file.id}
                                    control={
                                        <Checkbox
                                            checked={isChecked(file.id)}
                                            onChange={(event) => handleCheckboxChange(event, file.id)}
                                        />
                                    }
                                    label={file.title}
                                />
                            ))}
                        </FormGroup>
                    </Stack>
                ))}

            <Grid container justifyContent="center" pt="1rem">
                <LocalizedStrict id="support-create-supplier-subscription-status-begin-onboarding-dialog-button-next">
                    <StandardButton
                        fullWidth={false}
                        onClick={handleNext}
                        disabled={values.articles.length === 0}
                        type="button"
                    >
                        Next
                    </StandardButton>
                </LocalizedStrict>
            </Grid>
        </Stack>
    )
}
